import { defineStore } from 'pinia';
import { guideTourConfig } from '@/config/constants';

const TOUR_STORAGE_KEY = 'guide_tour_completed';

export const useGuideTourStore = defineStore('guideTour', () => {
  const isFirstVisit = ref(!localStorage.getItem(TOUR_STORAGE_KEY));
  const currentPhase = ref<'idle' | 'overview' | 'page'>('idle');
  const autoGuidePending = ref(false);

  function markTourCompleted() {
    localStorage.setItem(TOUR_STORAGE_KEY, Date.now().toString());
    isFirstVisit.value = false;
  }

  function resetTourStatus() {
    localStorage.removeItem(TOUR_STORAGE_KEY);
    isFirstVisit.value = true;
  }

  function setCurrentPhase(phase: 'idle' | 'overview' | 'page') {
    currentPhase.value = phase;
  }

  function requestAutoGuideForUser(user: any) {
    autoGuidePending.value = false;
    const creationTime = user?.creationTime;
    if (!creationTime)
      return false;

    const createdAt = new Date(String(creationTime).replace(' ', 'T')).getTime();
    if (!Number.isFinite(createdAt))
      return false;

    const accountAge = Date.now() - createdAt;
    const newUserWindow = guideTourConfig.newUserHours * 60 * 60 * 1000;
    const shouldShow = accountAge >= 0 && accountAge <= newUserWindow;
    autoGuidePending.value = shouldShow;
    return shouldShow;
  }

  function consumeAutoGuideRequest() {
    autoGuidePending.value = false;
  }

  return {
    isFirstVisit,
    currentPhase,
    autoGuidePending,
    markTourCompleted,
    resetTourStatus,
    setCurrentPhase,
    requestAutoGuideForUser,
    consumeAutoGuideRequest,
  };
});
